import * as React from 'react';

import './hoa-splash-photo.scss';

export default class SplashPhoto extends React.Component<{}, {}> {
	public render() {
		return (
			<div key='loading-background-gradient' className='splash-photo-gradient'/>
		);
	}
}
